import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { defaultsDeep } from 'lodash-es';
import { type PartialDeep } from 'type-fest';

import { type IChartsConfig } from './charts.interface';
import {
  CHARTS_CONFIG,
  CHARTS_USER_CONFIG,
  ChartsConfig,
} from './providers/charts-config';

let chartJsRegistered = false;

// Chart.js v4 is tree-shakable: controllers, scales, elements, and plugins
// must be explicitly registered. Calling this from `provideChartsConfig`
// guarantees the registration runs at bootstrap regardless of bundler
// side-effect handling.
function registerChartJs(): void {
  if (chartJsRegistered) {
    return;
  }

  Chart.register(...registerables, zoomPlugin);
  chartJsRegistered = true;
}

function userConfigFactory(
  userConfig: PartialDeep<IChartsConfig>,
): ChartsConfig {
  return defaultsDeep(userConfig, new ChartsConfig());
}

export function provideChartsConfig(
  config: Partial<IChartsConfig> = {},
): EnvironmentProviders {
  registerChartJs();

  return makeEnvironmentProviders([
    {
      provide: CHARTS_USER_CONFIG,
      useValue: config,
    },
    {
      provide: CHARTS_CONFIG,
      useFactory: userConfigFactory,
      deps: [CHARTS_USER_CONFIG],
    },
  ]);
}
